import {
  NotificationGate,
  notificationByIdQuery,
} from '@/entities/notifications'
import { ROUTES } from '@/shared/config'
import {
  ContentWrapper,
  ErrorResult,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { NotificationForm } from '@/widgets/NotificationForm'
import { Breadcrumb, Layout } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useParams } from 'react-router-dom'

export const NotificationEditPage = () => {
  const { id } = useParams<{ id: string }>()
  const notification = useUnit(notificationByIdQuery)

  return (
    <Layout>
      {id && <NotificationGate id={id} />}

      <HidingSpin
        spinning={
          notification.pending || (!notification.data && !notification.error)
        }
      >
        {notification.data && !notification.error ? (
          <>
            <HeaderContent
              breadcrumbSlot={
                <Breadcrumb
                  items={[
                    { title: 'Настройки' },
                    {
                      title: (
                        <Link to={ROUTES.SETTINGS.NOTIFICATIONS}>
                          Push уведомления
                        </Link>
                      ),
                    },
                    {
                      title: notification.data.name,
                    },
                  ]}
                />
              }
              title="Редактирование Push уведомления"
              description="Раздел позволяет редактировать шаблон Push уведомления"
            />

            <ContentWrapper>
              <NotificationForm />
            </ContentWrapper>
          </>
        ) : (
          <ContentWrapper>
            <ErrorResult
              error={notification.error}
              notFoundConfig={{
                subTitle: 'Данного уведомления не существует.',
                navigateTo: ROUTES.COLLECTIONS.ROOT,
              }}
            />
          </ContentWrapper>
        )}
      </HidingSpin>
    </Layout>
  )
}
